(() => {
  const SELECTOR_ROOT_CLASS = 'icons_slider';
  const SELECTOR_ELEMENTS_CLASS = 'icons_slider__elements';
  const SELECTOR_ARROW_CLASS = 'icons_slider__arrow';
  const SELECTOR_ARROW_PREV_CLASS = 'icons_slider__arrow--prev';
  const SELECTOR_ARROW_NEXT_CLASS = 'icons_slider__arrow--next';
  const SELECTOR_DOTS_WRAPPER_CLASS = 'icons_slider__dots';

  const iconsSliders = document.querySelectorAll(`.${SELECTOR_ROOT_CLASS}`);

  const initSliders = () => {
    if (!iconsSliders.length) {
      return;
    }

    iconsSliders.forEach((iconsSlider) => {
      initSlider(iconsSlider);
    })
  };

  const initSlider = (slider) => {
    const elementsWrapper = slider.querySelector(`.${SELECTOR_ELEMENTS_CLASS}`);
    
    jQuery(elementsWrapper).slick(getSlickSettings(slider));
  };

  const getSlickSettings = (slider) => {
    return {
      prevArrow: `<div class="${SELECTOR_ARROW_CLASS} ${SELECTOR_ARROW_PREV_CLASS}">${getSVGLeftChevron()}</div>`,
      nextArrow: `<div class="${SELECTOR_ARROW_CLASS} ${SELECTOR_ARROW_NEXT_CLASS}">${getSVGRightChevron()}</div>`,
      dots: true,
      appendDots: slider.querySelector(`.${SELECTOR_DOTS_WRAPPER_CLASS}`),
      mobileFirst: true,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 0,
          settings: {
            slidesToShow: 1,
            variableWidth: true,
          }
        },
        {
          breakpoint: 540,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 3,
            variableWidth: false,
          }
        },
        {
          breakpoint: 1140,
          settings: {
            slidesToShow: 4,
          }
        },
      ]
    }
  };

  const getSVGLeftChevron = () => {
    return `<svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.334961 12.0741L0.820711 11.5382L10.4676 0.819441L11.665 1.89136L2.50393 12.074L11.665 22.2567L10.4676 23.3286L0.820711 12.6098L0.334961 12.0739L0.334961 12.0741Z" fill="white"/>
    </svg>`
  }

  const getSVGRightChevron = () => {
    return `<svg width="12" height="24" viewBox="0 0 12 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.665 12.0741L11.1793 11.5382L1.5324 0.819441L0.33496 1.89136L9.49607 12.074L0.334961 22.2567L1.5324 23.3286L11.1793 12.6098L11.665 12.0739L11.665 12.0741Z" fill="white"/>
    </svg>
    `
  }

  document.addEventListener('DOMContentLoaded', initSliders);
})()